define( [
	"./arr"
], function( arr ) {
	return arr.push;
} );



/*****************
 ** WEBPACK FOOTER
 ** F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/~/jquery/src/var/push.js
 ** module id = 819
 ** module chunks = 2
 **/